import axios from 'axios';

const api = axios.create({
  baseURL: 'https://sfici2.pm.mt.gov.br/api',
  // baseURL: 'http://192.168.100.10:3333',
  withCredentials: true,
});

export default api;
